import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'toggle'];

  connect() {
    this.hasBeenRevealed = false;
    this.toggle();
  }

  toggle() {
    if (!this.hasBeenRevealed && this.inputTarget.value.trim() !== '') {
      this.toggleTarget.classList.add('field-reveal-visible');
      this.hasBeenRevealed = true;
    } else if (!this.hasBeenRevealed) {
      this.toggleTarget.classList.remove('field-reveal-visible');
    }
  }
}
